"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driveType = void 0;
exports.driveType = [
    {
        id: 'AWD',
        value: 'AWD',
        name: 'All Wheel',
        regex: /awd|all/i,
        is_searchable: true
    },
    {
        id: '4WD',
        value: '4WD',
        name: '4 Wheel',
        regex: /4wd|4.*wheel/i,
        is_searchable: false
    },
    {
        id: '4X4',
        value: '4X4',
        name: '4X4',
        regex: /4x4|by.*4|by.*four/i,
        is_searchable: true
    },
    {
        id: '4X2',
        value: '4X2',
        name: '4X2',
        regex: /4x2|by.*2|by.*two/i,
        is_searchable: true
    },
    {
        id: 'FWD',
        value: 'FWD',
        name: 'Front Wheel',
        regex: /fwd|front/i,
        is_searchable: true
    },
    {
        id: 'RWD',
        value: 'RWD',
        name: 'Rear Wheel',
        regex: /rwd|rear/i,
        is_searchable: true
    },
];
